import React from 'react'
import PropTypes from 'prop-types'

const Modal = ({
  children,
  title,
  setShow,
  disabled = false,
  btnTxtCancel = 'Cancel',
  btnTxtSubmit = 'Submit',
  btnTxtAlt = '',
  callback,
}) => {
  const onCancel = () => {
    callback(false)
    setShow(false)
  }

  const onSubmit = () => {
    callback(true)
    setShow(false)
  }

  const onAlt = () => {
    setShow(false)
  }

  return (
    <div
      onClick={onCancel}
      className="fixed top-0 left-0 w-screen h-screen align-top bg-modal-background"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative max-w-md px-12 py-6 mx-auto my-0 bg-white rounded-lg shadow-2xl"
        style={{ marginTop: '15vh' }}
      >
        <div className="mb-6 text-2xl text-pink-400">{title}</div>
        <div className="">{children}</div>
        <div className="flex items-center justify-end mt-6 mb-4">
          <button
            onClick={onCancel}
            className="px-4 py-2 mr-2 text-sm text-gray-500 hover:underline"
          >
            {btnTxtCancel}
          </button>
          <button disabled={disabled} onClick={onSubmit} className="btn">
            {btnTxtSubmit}
          </button>
        </div>
      </div>
    </div>
  )
}

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  setShow: PropTypes.func.isRequired,
  callback: PropTypes.func.isRequired,
  btnTxtCancel: PropTypes.string,
  btnTxtSubmit: PropTypes.string,
}

export default Modal
